import React from 'react';

export default function Memorial() {
  return (
    <section className="relative overflow-hidden bg-[#0f1a14] py-24 lg:py-32">
      <div className="mx-auto max-w-6xl px-6 lg:px-10 grid md:grid-cols-5 gap-12 items-center">
        <div className="md:col-span-2">
          <div className="relative aspect-[4/5] overflow-hidden border border-[#c9a56a]/30">
            <img
              src="https://ewenrealtors.com/assets/images/nayak-kesar-singh-rawat-ji.jpeg"
              alt="Late Nayak Kesar Singh Rawat"
              className="h-full w-full object-cover grayscale"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0f1a14] via-transparent to-transparent" />
          </div>
        </div>
        <div className="md:col-span-3">
          <div className="flex items-center gap-3 mb-5">
            <div className="h-px w-12 bg-[#c9a56a]" />
            <span className="text-[#c9a56a] text-xs uppercase tracking-[0.3em]">In Loving Memory</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-white leading-[1.1]">
            A flat <em className="text-[#c9a56a] not-italic">5% off</em> for the families of our soldiers.
          </h2>
          <img src="https://ewenrealtors.com/assets/images/separator.svg" alt="" className="my-6 h-4 opacity-70" />
          <p className="text-white/70 leading-relaxed">
            In memory of <span className="text-white">Late Nayak Kesar Singh Rawat</span> {'\u2014'} father of our Chairman, Mr. Rajesh Rawat {'\u2014'} who was martyred in 1996 while securing the Kargil border, we offer a flat 5% discount to the families of Indian soldiers.
          </p>
          <p className="text-white/70 leading-relaxed mt-4">
            We salute every brave soldier who gave their life fearlessly to protect our nation. Their courage lives on in every home we build.
          </p>
        </div>
      </div>
    </section>
  );
}
